import React from 'react'

export default (props) => {
    const {student} = props
    if (!student || !student.class || !student.level || !student.year) {
        return null
    }
    return (<span className="badge">{student.level.name} {student.year.year} • {student.class}</span>)
}